<template>
  <div class="container">
    <!-- Modal -->
    <div v-if="this.$store.state.modal.adicionarGlosa.show === true" class="in show modal fade adicionarGlosa" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div :class="[(this.$store.state.modal.adicionarGlosa.status) ? 'sucesso' : 'falhou', 'modal-header']">

            <button type="button" class="close" data-dismiss="modal" v-on:click="fecharModal()">&times;</button>

            <h4 class="modal-title alert-title">
               <span> <b-icon icon="wallet2"></b-icon> </span> Evidência de glosa
            </h4>

          </div>

            <div class="modal-body content-body">
                <form-adicionar-glosa
                  :contrato="this.$store.state.contrato"
                  :fecharModal="fecharModal"
                />
            </div>

        </div>

      </div>
    </div>
  </div>

</template>
<script>
import formAdicionarGlosa from '../form/FormAdicionarGlosa.vue'

export default {
  components: {
    'form-adicionar-glosa': formAdicionarGlosa
  },
  methods: {
    fecharModal: function () {
      this.$store.commit('setAdicionarGlosa', {conteudo: null, show: false})
    }
  }
}
</script>
<style scoped src="../css/modalFormAdicionarEvidenciaGlosa.css"></style>



// WEBPACK FOOTER //
// ModalAdicionarEvidenciaGlosa.vue?679b0001